import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                "@font-face": {
                    fontDisplay: "swap",
                    fontFamily: "Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue",
                    fontStyle: "normal",
                    fontWeight: 400,
                },
            },
        },
    },

    palette: {
        action: {
            activatedOpacity: 0.12,
            disabledBackgroundOpacity: 0.24,
            disabledOpacity: 0.48,
            focusOpacity: 0.12,
            hoverOpacity: 0,
            selectedOpacity: 0.08,
        },

        background: {
            default: "#f0f2f5",
        },

        chip: {
            background: {
                active: "#D7E9FF",
                completed: "#54D62C29",
                failed: "#FFE2E1",
                stopped: "#FFF7CD",
            },
            color: {
                active: "#0381B7",
                completed: "#438256",
                failed: "#B72136",
                stopped: "#7A4F01",
            },
        },
        error: {
            main: "#eb2f06",
            secondary: "#FFE7E1",
            third: "#FF6A4D",
        },

        grey: {
            100: "#FFF",
            200: "#F4F6F8",
            300: "#DFE3E8",
            400: "#C4CDD5",
            500: "#919EAB",
            600: "#637381",
            700: "#454F5B",
            800: "#212B36",
            900: "#161C24",
            901: "rgba(0, 0, 0, 0.54)",
            902: "rgba(0, 0, 0, 0.1)",
            903: "linear-gradient(180deg, rgba(32, 30, 31, 0.63) 0%, rgba(41, 45, 50, 0) 76.56%)",
            904: "#E0E0E0",
            905: "#000",
        },

        pending: {
            main: "#FAE316",
        },

        primary: {
            main: "#248551",
        },

        progressBar: {
            background: {
                active: "#D7E9FF",
                completed: "#C8FACD",
                delayed: "#FFE7D9",
                failed: "#FFE7D9",
                paused: "#F4F6F8",
                waiting: "#FFF7CD",
            },
            color: {
                active: "#0381B7",
                completed: "#438256",
                delayed: "#B76E00",
                failed: "#FF4842",
                paused: "#637381",
                waiting: "#B78103",
            },
        },

        secondary: {
            main: "#2485511a",
        },

        snackbar: {
            background: {
                error: "#FFE7D9",
                info: "#FFF7CD",
                success: "#E9FCD4",
            },
            color: {
                error: "#7A0C2E",
                info: "#7A4F01",
                success: "#08660D",
            },
        },
        success: {
            main: "#54D62C",
            secondary: "#E9F9E4",
            third: "#7BDD6E",
        },

        warning: { main: "#FFC107" },
    },
});
